import { render, staticRenderFns } from "./YtdLevel1.vue?vue&type=template&id=a55cca4a&scoped=true"
import script from "./YtdLevel1.vue?vue&type=script&lang=js"
export * from "./YtdLevel1.vue?vue&type=script&lang=js"
import style0 from "./YtdLevel1.vue?vue&type=style&index=0&id=a55cca4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a55cca4a",
  null
  
)

export default component.exports